export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-285x161.6f8e21b4.png";